import React, { Component, CSSProperties } from 'react';

class CustomBadge extends Component<Props> {
  public render() {
    const { value, color, style } = this.props;
    return (
      <div className='rounded-full min-w-5 min-h-5 px-2.5 text-white inline-flex items-center justify-center' style={{ background: color ?? '#red', ...style }}>
        {value}
      </div>
    );
  }
}

interface Props {
  value: string | React.ReactNode;
  style?: CSSProperties;
  color?: string;
}

export default CustomBadge;
